import { PubSubModule } from '../../utils/eventUtils';

export const ExceptionBus = new PubSubModule();
